import React from 'react';
import { Star } from 'lucide-react';
interface Testimonial {
  name: string;
  age: number;
  city: string;
  initial: string;
  text: string;
  result: string;
  stars: number;
}
const testimonials: Testimonial[] = [{
  name: 'Jorge Bentancur',
  age: 58,
  city: 'Salto',
  initial: 'J',
  text: 'Mirá, yo era de los que pensaba que esto era todo verso. Llevaba tres años con la glucosa arriba de 140 y el médico ya me estaba hablando de insulina. Mi señora me convenció de probar. La primera semana no creía mucho, pero al séptimo día me medí y tenía 108. Che, casi me caigo de espaldas. Ahora el domingo como el asado tranquilo, sin esa culpa de antes.',
  result: 'Bajó de 142 a 108 en 7 días',
  stars: 5
}, {
  name: 'Marta Silveira',
  age: 63,
  city: 'Montevideo',
  initial: 'M',
  text: 'Tengo 63 años y toda la vida fui a la feria del barrio. Cuando leí lo de las hierbas me acordé de mi abuela que tomaba cedrón y carqueja para todo. Seguí el protocolo al pie de la letra y ta, los resultados hablan solos. Lo que más me sorprendió fue que dejé de tener ese hormigueo en los pies que me molestaba de noche. Fenómeno, de verdad.',
  result: 'Glucosa estabilizada + desapareció el hormigueo',
  stars: 5
}, {
  name: 'Carlos Techera',
  age: 55,
  city: 'Paysandú',
  initial: 'C',
  text: 'Soy camionero, como en la ruta, no puedo andar con dietas raras. Lo que me gustó de este protocolo es que no te pide que dejes de comer, te enseña cómo manejar lo que ya comés. El truco del post-asado es una joya, qué sé yo cómo no se me había ocurrido antes. Mis análisis del mes pasado salieron los mejores en cinco años.',
  result: 'Mejores análisis en 5 años',
  stars: 5
}, {
  name: 'Graciela Moreira',
  age: 67,
  city: 'Maldonado',
  initial: 'G',
  text: 'Mi hija me lo mandó por WhatsApp y al principio pensé que era una de esas cosas de internet. Pero ella me insistió y lo compré. Qué bueno que lo hice. Tenía la glucosa en 156 y en diez días la bajé a 118. El médico me preguntó qué había hecho diferente. Le conté y se quedó pensando. Ahora le recomiendo el protocolo a todas mis amigas del club.',
  result: 'De 156 a 118 en 10 días',
  stars: 5
}, {
  name: 'Roberto Píriz',
  age: 52,
  city: 'Rivera',
  initial: 'R',
  text: 'Dale, voy a ser honesto: las primeras dos semanas no vi mucho cambio y casi pido el reembolso. Pero seguí porque la garantía me daba tranquilidad. A la tercera semana empecé a notar que me despertaba con más energía y que después del almuerzo no me daba ese sueño que me mataba. La glucosa bajó de a poco pero bajó. Hoy estoy en 99. Bárbaro.',
  result: 'Bajó a 99 + más energía diaria',
  stars: 4
}, {
  name: 'Elsa Domínguez',
  age: 60,
  city: 'Melo',
  initial: 'E',
  text: 'Lo que más me costaba era el mate de la mañana con galletas. Acá te explican cómo hacerlo sin que te dispare el azúcar. Aprendí un montón sobre cómo funciona mi cuerpo. Llevo dos meses con la glucosa entre 95 y 105, algo que no lograba ni con la pastilla que tomaba. Mi médico redujo la dosis a la mitad. Eso para mí es un logro enorme.',
  result: 'Médico redujo la medicación a la mitad',
  stars: 5
}];
function StarRating({
  count
}: {
  count: number;
}) {
  return <div className="flex gap-0.5" data-id="element-331">
      {[1, 2, 3, 4, 5].map(i => <Star key={i} className={`h-4 w-4 ${i <= count ? 'fill-amber-400 text-amber-400' : 'text-gray-300'}`} data-id="element-332" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-16 px-4 bg-[#faf7f0]" data-id="element-333">
      <div className="max-w-5xl mx-auto" data-id="element-334">
        <div className="text-center mb-12" data-id="element-335">
          <div className="inline-block bg-emerald-100 text-emerald-800 px-4 py-1 rounded-full text-sm font-bold mb-4 uppercase tracking-wide" data-id="element-336">
            Testimonios reales
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a4a2e] mb-3" data-id="element-337">
            Lo Que Dicen los Uruguayos que Ya lo Probaron
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-338">
            Más de 1.200 personas en todo el país ya están viviendo los
            resultados.
          </p>
          <div className="flex items-center justify-center gap-2 mt-3" data-id="element-339">
            <div className="flex gap-0.5" data-id="element-340">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="h-5 w-5 fill-amber-400 text-amber-400" data-id="element-341" />)}
            </div>
            <span className="text-gray-700 font-semibold" data-id="element-342">
              4.9 / 5 promedio
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-343">
          {testimonials.map(t => <div key={t.name} className="bg-white rounded-2xl p-6 shadow-md border border-gray-100 flex flex-col gap-4" data-id="element-344">
              <div className="flex items-start justify-between" data-id="element-345">
                <div className="flex items-center gap-3" data-id="element-346">
                  <div className="w-11 h-11 rounded-full bg-[#1a4a2e] text-white flex items-center justify-center font-bold text-lg flex-shrink-0" data-id="element-347">
                    {t.initial}
                  </div>
                  <div data-id="element-348">
                    <p className="font-bold text-gray-900 text-sm" data-id="element-349">{t.name}</p>
                    <p className="text-xs text-gray-500" data-id="element-350">
                      {t.age} años · {t.city}
                    </p>
                  </div>
                </div>
                <StarRating count={t.stars} data-id="element-351" />
              </div>

              <p className="text-gray-700 text-sm leading-relaxed italic" data-id="element-352">
                "{t.text}"
              </p>

              <div className="mt-auto pt-3 border-t border-gray-100" data-id="element-353">
                <div className="inline-flex items-center gap-1.5 bg-emerald-50 text-emerald-800 px-3 py-1 rounded-full text-xs font-bold" data-id="element-354">
                  ✅ {t.result}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}